<template>
  <div class="row mb-2">
    <div class="col-6">
      <h5>Basisinformationen</h5>
    </div>
  </div>

  <div v-if="unemployedData">
    <div class="row mb-1">
      <div class="col-6">
        <h6 v-if="unemployedData.status === 'new'">
          <span style="padding-right: 10px;">Status: </span>
          <div class="status-pill orange p-2 mr-2" :data-title="unemployedData.statusTranslated" data-toggle="tooltip"
               title=""></div>
          {{ unemployedData.statusTranslated }}
        </h6>

        <h6 v-if="unemployedData.status === 'active'">
          <span style="padding-right: 10px;">Status: </span>
          <div class="status-pill green p-2 mr-1" :data-title="unemployedData.statusTranslated" data-toggle="tooltip"
               title=""></div>
          {{ unemployedData.statusTranslated }}
        </h6>

        <h6 v-if="unemployedData.status === 'finished'">
          <span style="padding-right: 10px;">Status: </span>
          <div class="status-pill red p-2 mr-1" :data-title="unemployedData.statusTranslated" data-toggle="tooltip"
               title=""></div>
          {{ unemployedData.statusTranslated }}
        </h6>
      </div>
    </div>

    <div class="row m-0 portal_user_data">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <p style="font-size: 16px; margin-bottom: 10px"><span class="pr-1">Kundennummer: </span>
          {{ unemployedData.customerNumber }}</p>
        <p style="font-size: 16px; margin-bottom: 10px"><span class="pr-1">Standort: </span>
          <span v-if="unemployedData.location">
            {{ unemployedData.location.name }}
          </span>
        </p>
        <p style="font-size: 16px; margin-bottom: 10px"><span class="pr-1">JC / AA Nummer: </span>
          {{ unemployedData.aaNumber }}</p>
        <p style="font-size: 16px; margin-bottom: 10px"><span class="pr-1">Versicherungsnr: </span>
          {{ unemployedData.insuranceNumber }}</p>
        <p style="font-size: 16px; margin-bottom: 10px"><span class="pr-1">Erstellt am Tag: </span>
          {{ unemployedData.createdAt }}
        </p>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-12">
        <p style="font-size: 16px; margin-bottom: 10px"><span class="pr-1">Vorname: </span>
          {{ unemployedData.firstName }}
        </p>
        <p style="font-size: 16px; margin-bottom: 10px"><span class="pr-1">Nachname: </span>
          {{ unemployedData.lastName }}
        </p>
        <p style="font-size: 16px; margin-bottom: 10px"><span class="pr-1">Telefonnummer: </span>
          {{ unemployedData.phone }}
        </p>
        <p style="font-size: 16px; margin-bottom: 10px"><span class="pr-1">E-Mail: </span> {{ unemployedData.email }}
        </p>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-12">
        <p style="font-size: 16px; margin-bottom: 10px"><span class="pr-1">Straße: </span> {{
            unemployedData.address
          }}</p>
        <p style="font-size: 16px; margin-bottom: 10px"><span class="pr-1">PLZ: </span> {{ unemployedData.zip }}</p>
        <p style="font-size: 16px; margin-bottom: 10px"><span class="pr-1">Ort: </span> {{ unemployedData.city }}</p>
        <p style="font-size: 16px; margin-bottom: 10px"><span class="pr-1">Geburtsdatum: </span> {{
            unemployedData.birthdate
          }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  unemployedData: {
    require: true,
  },
});
</script>


<style scoped>

</style>